import { useSettings } from '@capsicum/common';
import { BaseTutorialCard, useTutorial, useTutorialStyles } from '@capsicum/common-web';
import { useEffect } from 'react';

export const useRPAuctionsTutorial = (isLoading: boolean) => {
	const { setup } = useTutorial();
	const { settings } = useSettings();

	const { highlightedAreaStyle, popoverStyles } = useTutorialStyles();

	useEffect(() => {
		if (!isLoading && settings.areTutorialsEnabled.auctionsLobby) {
			setup('auctions', {
				steps: [
					{
						content: (
							<BaseTutorialCard
								content="rewards.rpAuctions.tutorials.rpAuctions.steps.content"
								title="rewards.rpAuctions.tutorials.rpAuctions.steps.title"
							/>
						),
						padding: 0,
						position: 'top',
						selector: '[data-tutorial="RPAuctionsTutorial"]',
						stepInteraction: false,
						styles: {
							highlightedArea: highlightedAreaStyle({ disableInteraction: true }),
							popover: base => ({
								...base,
								...popoverStyles()?.({ ...base, top: -32 })
							})
						}
					}
				]
			});
		}
	}, [highlightedAreaStyle, setup, isLoading, popoverStyles, settings]);
};
